<template>
  <div v-if="isVisible" class="container">
    <h1>PresenceEditor</h1>
    <div class="d-flex mx-auto">
      <iframe v-if="iframeUrl" :src="iframeUrl" style="height:1200px;width:100%" title="Typeform"></iframe>
    </div>
    <div>
      <pre>User ID: {{ userId }}</pre>
      <pre>Presence ID: {{ presenceId }}</pre>
      <pre>iFrame URL: {{ iframeUrl }}</pre>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import decode from 'jwt-decode';
import { useStore } from 'vuex';
import md5 from 'crypto-js/md5';

const route = useRoute()
const store = useStore();
const userData = computed(() => store.getters['auth/getUserData']);
const authTokenDecoded = computed(() => userData?.value?.authToken ? decode(userData.value?.authToken) : '');
const userId = computed(() => authTokenDecoded.value?.sub || '');
const presenceId = computed(() => authTokenDecoded.value?.presenceId || '');

const isVisible = computed(() => route.query?.['__dev'] === 'true')

const iframeUrl = computed(() => {
  if (presenceId.value && userId.value) {
    const token = md5(userId.value).toString();
    return `https://form.typeform.com/to/v9TIN5I4#id=${presenceId.value}&token=${token}`;
  }
  return '';
});
</script>
